import { observable } from "mobx";
import CustomerRefundApplicationRejectionReason from "./customerRefundApplicationRejectionReason";
import CustomerRefundApplicationWarningReason from "./customerRefundApplicationWarningReason";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CustomerRefundApplicationProductionResponse {
  /**
   * If true - application is valid and can be submitted.
   */
  @observable
  canBeAppliedFor!: boolean;

  @observable
  rejectionReason?: CustomerRefundApplicationRejectionReason;

  /**
   * Warning reasons.
   */
  @observable
  warningReasons?: CustomerRefundApplicationWarningReason[];

  /**
   * Charge management URL - only filled when charge before validity exists.
   */
  @observable
  chargeManagementUrl?: string;
}
